import React from 'react';
import { motion } from 'motion/react';

export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-24 pb-32 sm:pt-32 sm:pb-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          >
             <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-900 px-3 py-1 text-[19px] font-medium text-slate-800 dark:text-slate-200 ring-1 ring-inset ring-slate-200 dark:ring-slate-800 mb-8">
              Independent Publisher & Studio
             </span>
          </motion.div>
          <motion.h1 
            className="font-serif text-5xl font-semibold tracking-tight text-slate-900 dark:text-slate-50 sm:text-7xl transition-colors duration-300"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut', delay: 0.05 }}
          >
            Crafting stories.<br /> Building experiences.
          </motion.h1>
          <motion.p 
            className="mt-8 text-lg font-medium leading-8 text-slate-600 dark:text-slate-300 sm:text-xl transition-colors duration-300"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut', delay: 0.1 }}
          >
            At RingTail Press, we bridge the gap between traditional publishing and modern technology. We publish thought-provoking books and develop intuitive digital applications designed to enrich the reading and creative process.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
